<template>
  <aw-cms-page :content-data="previewData" :class="$style.page" />
</template>

<script setup lang="ts">
  import { computed, onMounted, defineAsyncComponent } from 'vue';
  import { useHead } from 'nuxt/app';
  import { useContentsStore } from '~~/common/stores/contents';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface';
  const AwCmsPage = defineAsyncComponent(() => import('~~/common/components/Page/Content/AwCmsPage.vue'));

  defineOptions({
    name: 'AwContentPreviewPageHash',
  });
  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });
  useHead({
    meta: [
      {
        name: 'robots',
        content: 'noindex,nofollow',
      },
    ],
  });
  const contentsStore = useContentsStore();
  const previewData = computed(() => contentsStore.previewData);
  onMounted(() => {
    const { setBackground } = useUserInterfaceStore();
    setBackground({ ...previewData.value });
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.page {
  padding-bottom: 20px;

  @include tablet(min) {
    padding-bottom: 40px;
  }
}
</style>
